export const CHANNELS_LIMIT = 100;
export const OFFERS_LIMIT = 100;
export const OPTIONS_MAX_HEIGHT_MAIN = 300;
export const OPTIONS_MAX_HEIGHT_EXTENDED = 300;
export const OPTIONS_MAX_HEIGHT_CHANNEL = 300;
export const OPTIONS_MAX_HEIGHT_NOTIFICATIONS = 300;
